import loadable from '@loadable/component';

const HomeLoadable = loadable(() => import(/* webpackChunkName: 'home' */ './Home'));

const Home = (props: any) => <HomeLoadable {...props} />;

export default Home;
